import React, { Component } from 'react';
import axios from "../../utils/axiosInstance";
import './Calendar.css';

const apiBaseUrl = axios.defaults.baseURL || "";
const uploadUrl = `${apiBaseUrl.replace(/\/api\/?$/, "")}/uploads/posts/`;

class Calendar extends Component {
  constructor(props) {
    super(props);
    
    const today = new Date(); 
    
    this.state = {
      today: today,
      baseMonth: new Date(today.getFullYear(), today.getMonth(), 1),
      properties: [],
      selectedProperty: null,
      dropdownOpen: false,
      searchQuery: "",
      
      bookedDatesMap: {}, 
      selectedDates: [],  
      showPopup: false,
      customPrice: '0',
      actionType: '',     
      
      loading: true,
      loadingBookedDates: false,
      error: null,
    };
  }

  componentDidMount() {


    const web_user_id =
      localStorage.getItem("web_user_id") ||
      sessionStorage.getItem("web_user_id");

    if (
      !web_user_id ||
      web_user_id === "null" ||
      web_user_id === "undefined" ||
      String(web_user_id).trim() === ""
    ) {
      window.location.replace("/searchresultmobile");
      return;
    }

    this.fetchProperties();
  }

  fetchProperties = async () => {
    try {
      this.setState({ loading: true, error: null });
      const web_user_id = localStorage.getItem("web_user_id") || "28";
      
      const response = await axios.get(`/get_customer_posts?id=${web_user_id}`);
      const data = response?.data?.data || [];
      
      this.setState({ 
        properties: data, 
        loading: false,
        selectedProperty: data.length > 0 ? data[0] : null
      });

      if (data.length > 0) {
        this.fetchBookedDates(data[0].id);
        if (data[0].sales_price || data[0].regular_price) {
          this.setState({ customPrice: data[0].sales_price || data[0].regular_price });
        }
      }
    } catch (err) {
      console.error("Error fetching properties:", err);
      this.setState({ loading: false, error: "Failed to load properties list." });
    }
  };

  fetchBookedDates = async (propertyId) => {
    if (!propertyId) return;

    try {
      this.setState({ loadingBookedDates: true });
      const response = await axios.get(`/booked_dates?post_id=${propertyId}`);
      const rawBookings = response?.data?.data || [];
      const newBookedMap = {};

      rawBookings.forEach((booking) => {
        if (booking.checkin_date && booking.checkout_date) {
          let current = new Date(booking.checkin_date + "T00:00:00");
          const end = new Date(booking.checkout_date + "T00:00:00");

          while (current <= end) {
            const y = current.getFullYear();
            const m = String(current.getMonth() + 1).padStart(2, '0');
            const d = String(current.getDate()).padStart(2, '0');
            const formattedDate = `${y}-${m}-${d}`;

            newBookedMap[formattedDate] = booking.id; 
            current.setDate(current.getDate() + 1);
          }
        }
      });

      this.setState({ bookedDatesMap: newBookedMap, loadingBookedDates: false });
    } catch (err) {
      console.error("Error fetching booked dates:", err);
      this.setState({ bookedDatesMap: {}, loadingBookedDates: false });
    }
  };

  handlePrevMonth = () => {
    this.setState(prevState => ({
      baseMonth: new Date(prevState.baseMonth.getFullYear(), prevState.baseMonth.getMonth() - 1, 1)
    }));
  };

  handleNextMonth = () => {
    this.setState(prevState => ({
      baseMonth: new Date(prevState.baseMonth.getFullYear(), prevState.baseMonth.getMonth() + 1, 1)
    }));
  };

  getMonthsToRender = () => {
    const { baseMonth } = this.state;
    const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    
    const m1 = new Date(baseMonth.getFullYear(), baseMonth.getMonth(), 1);
    const m2 = new Date(baseMonth.getFullYear(), baseMonth.getMonth() + 1, 1);
    
    return [
      { year: m1.getFullYear(), month: m1.getMonth(), title: `${monthNames[m1.getMonth()]} ${m1.getFullYear()}` },
      { year: m2.getFullYear(), month: m2.getMonth(), title: `${monthNames[m2.getMonth()]} ${m2.getFullYear()}` }
    ];
  };

  getDaysInMonth = (year, month) => new Date(year, month + 1, 0).getDate();
  getFirstDayOfMonth = (year, month) => new Date(year, month, 1).getDay();
  
  formatDateString = (year, month, day) => {
    const m = String(month + 1).padStart(2, '0');
    const d = String(day).padStart(2, '0');
    return `${year}-${m}-${d}`;
  };

  toggleDropdown = () => this.setState((prev) => ({ dropdownOpen: !prev.dropdownOpen }));

  handleSelectProperty = (property) => {
    this.setState({
      selectedProperty: property,
      dropdownOpen: false,
      searchQuery: "",
      selectedDates: [],
      customPrice: property.sales_price || property.regular_price || "0",
      actionType: '',
      showPopup: false
    });
    this.fetchBookedDates(property.id);
  };

  handleSearchChange = (e) => this.setState({ searchQuery: e.target.value });

  handleDateClick = (dateStr, dateObj) => {
    if (dateObj.isPast) return;

    let updatedSelected = [...this.state.selectedDates];
    
    if (updatedSelected.includes(dateStr)) {
      updatedSelected = updatedSelected.filter((d) => d !== dateStr);
    } else {
      updatedSelected.push(dateStr);
    }

    updatedSelected.sort();

    this.setState({
      selectedDates: updatedSelected,
      showPopup: updatedSelected.length > 0
    });
  };

  handlePriceChange = (e) => this.setState({ customPrice: e.target.value });
  
  handleActionToggle = (type) => {
    this.setState(prev => ({ actionType: prev.actionType === type ? '' : type }));
  };

  closePopup = () => this.setState({ showPopup: false, selectedDates: [], actionType: '' });

  clearAllMarked = () => this.setState({ selectedDates: [], showPopup: false, actionType: '' });

  handleUpdate = async () => {
    const { actionType, selectedDates, selectedProperty, customPrice, bookedDatesMap } = this.state;
    const postId = selectedProperty?.id;
    const webUserId = localStorage.getItem("web_user_id") || "28";

    if (!postId || selectedDates.length === 0) return;

    try {
      if (actionType === '') {
        await axios.get(`/post_custom_price?post_id=${postId}&sales_price=${customPrice}`);

        // Update selected property price locally in state immediately
        this.setState((prevState) => {
          const updatedProperty = prevState.selectedProperty
            ? { ...prevState.selectedProperty, sales_price: customPrice }
            : null;

          const updatedList = prevState.properties.map((p) =>
            p.id === postId ? { ...p, sales_price: customPrice } : p
          );

          return {
            selectedProperty: updatedProperty,
            properties: updatedList
          };
        });

        alert("Price updated successfully!");

      } else if (actionType === 'Available') {
        const bookIdsToClear = [...new Set(selectedDates.map(date => bookedDatesMap[date]).filter(id => id))];
        for (let bookId of bookIdsToClear) {
          await axios.get(`/set_available_booking?book_id=${bookId}`);
        }
        alert("Marked dates made available successfully!");

      } else if (actionType === 'Block') {
        const datesToBlock = selectedDates.filter((dateStr) => !bookedDatesMap[dateStr]);

        if (datesToBlock.length === 0) {
          alert("All selected dates are already blocked/booked.");
          return;
        }

        for (let dateStr of datesToBlock) {
          await axios.get("/book_create_by_host", {
            params: {
              post_id: postId,
              web_user_id: webUserId,
              checkin_date: dateStr,
              checkout_date: dateStr
            }
          });
        }

        alert("Marked dates blocked successfully!");
      }

      this.fetchBookedDates(postId);
      this.closePopup();

    } catch (error) {
      console.error("Error updating calendar:", error);
      alert("An error occurred while updating the calendar.");
    }
  };

  renderPropertyDropdown() {
    const { properties, selectedProperty, dropdownOpen, searchQuery } = this.state;
    const filteredProperties = properties.filter((p) =>
      (p.title || "").toLowerCase().includes(searchQuery.toLowerCase()) ||
      (p.real_address || "").toLowerCase().includes(searchQuery.toLowerCase())
    );

    return (
      <div className="cal-top-header">
        <div className="property-select-container">
          <div className="property-select-box" onClick={this.toggleDropdown}>
            {selectedProperty ? (
              <div className="selected-property-info">
                <img 
                  src={`${uploadUrl}${selectedProperty.feature_image}`} 
                  alt={selectedProperty.title} 
                  className="property-thumb"
                  onError={(e) => { e.target.src = "https://via.placeholder.com/50"; }}
                />
                <div className="property-details">
                  <h4 className="property-title">{selectedProperty.title}</h4>
                  <p className="property-address">{selectedProperty.real_address || "No address provided"}</p>
                  <span className="property-price">৳{selectedProperty.sales_price || selectedProperty.regular_price || 0} / night</span>
                </div>
              </div>
            ) : (
              <div className="selected-property-placeholder">
                <span>Select a property...</span>
              </div>
            )}
            <span className={`dropdown-arrow ${dropdownOpen ? 'open' : ''}`}>▼</span>
          </div>

          {dropdownOpen && (
            <div className="property-dropdown-menu">
              <input
                type="text"
                className="dropdown-search-input"
                placeholder="Search property..."
                value={searchQuery}
                onChange={this.handleSearchChange}
                autoFocus
              />
              <div className="dropdown-items-list">
                {filteredProperties.length > 0 ? (
                  filteredProperties.map((p) => (
                    <div 
                      key={p.id} 
                      className={`dropdown-item ${selectedProperty?.id === p.id ? 'active' : ''}`} 
                      onClick={() => this.handleSelectProperty(p)}
                    >
                      <img 
                        src={`${uploadUrl}${p.feature_image}`} 
                        alt={p.title} 
                        className="dropdown-thumb" 
                        onError={(e) => { e.target.src = "https://via.placeholder.com/50"; }}
                      />
                      <div className="dropdown-item-info">
                        <strong>{p.title}</strong>
                        <small>{p.real_address}</small>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="dropdown-no-results">No properties found.</div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  renderMonth(monthObj) {
    const { today, bookedDatesMap, selectedDates } = this.state;
    const { year, month, title } = monthObj;

    const daysInMonth = this.getDaysInMonth(year, month);
    const firstDayIndex = this.getFirstDayOfMonth(year, month);
    const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const emptyCells = Array.from({ length: firstDayIndex });
    const daysArray = Array.from({ length: daysInMonth }, (_, i) => i + 1);
    const now = new Date(today.getFullYear(), today.getMonth(), today.getDate());

    return (
      <div key={`${year}-${month}`} className="month-card">
        <h3 className="month-title">{title}</h3>
        <div className="weekdays-grid">
          {weekdays.map((day, idx) => (
            <div key={day} className={`weekday-cell ${idx === 0 ? 'sun-red' : ''}`}>{day}</div>
          ))}
        </div>

        <div className="days-grid">
          {emptyCells.map((_, idx) => (
            <div key={`empty-${idx}`} className="day-cell empty" />
          ))}

          {daysArray.map((day) => {
            const dateStr = this.formatDateString(year, month, day);
            const currentDateObj = new Date(year, month, day);

            const isPast = currentDateObj < now;
            const isToday = currentDateObj.getTime() === now.getTime();
            const isBooked = !!bookedDatesMap[dateStr];
            const isMarked = selectedDates.includes(dateStr);
            const dayOfWeek = currentDateObj.getDay();

            let cellClass = "day-cell";
            if (isPast) cellClass += " is-past";
            if (isToday) cellClass += " is-today";
            if (isBooked) cellClass += " is-booked";
            if (isMarked) cellClass += " is-marked";

            return (
              <div
                key={dateStr}
                className={cellClass}
                onClick={() => this.handleDateClick(dateStr, { isPast, isToday, isBooked, isMarked })}
              >
                <span className={`day-number ${dayOfWeek === 0 && !isPast && !isMarked ? 'sun-text' : ''}`}>{day}</span>
                {isMarked && <span className="check-mark-icon">✓</span>}
                {isBooked && !isMarked && <span className="booked-badge">Booked</span>}
                {isToday && !isMarked && <span className="today-dot" />}
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  render() {
    const { showPopup, customPrice, actionType, selectedDates, loading, error } = this.state;
    const monthsToRender = this.getMonthsToRender();
    
    return (
      <div className="app-container">
        {this.renderPropertyDropdown()}

        {selectedDates.length > 0 && (
          <div className="marked-bar-summary">
            <span><strong>{selectedDates.length}</strong> {selectedDates.length === 1 ? 'date' : 'dates'} marked</span>
            <div className="marked-summary-actions">
              <button className="manage-marked-btn" onClick={() => this.setState({ showPopup: true })}>
                Manage
              </button>
              <button className="clear-marked-btn" onClick={this.clearAllMarked}>Clear</button>
            </div>
          </div>
        )}
        
        {loading && (
          <div className="calendar-state-box">
            <div className="spinner" />
            <p>Loading properties...</p>
          </div>
        )}

        {!loading && error && (
          <div className="calendar-state-box error">
            <p>{error}</p>
          </div>
        )}

        {!loading && !error && (
          <>
            <div className="calendar-nav-controls">
              <button onClick={this.handlePrevMonth} className="nav-btn">❮ Prev</button>
              <button onClick={this.handleNextMonth} className="nav-btn">Next ❯</button>
            </div>

            <div className="calendar-months-wrapper">
              {monthsToRender.map((m) => this.renderMonth(m))}
            </div>
          </>
        )}

        {showPopup && (
          <div className="bottom-popup-overlay" onClick={this.closePopup}>
            <div className="bottom-popup-content" onClick={(e) => e.stopPropagation()}>
              <div className="popup-header">
                <div>
                  <h3>Update Marked Dates</h3>
                  <p className="popup-subtitle">
                    {selectedDates.length} {selectedDates.length === 1 ? 'date' : 'dates'} selected
                  </p>
                </div>
                <button className="close-btn" onClick={this.closePopup}>✕</button>
              </div>

              <div className="input-group">
                <label>Custom Price (৳)</label>
                <input
                  type="number"
                  value={customPrice}
                  onChange={this.handlePriceChange}
                  placeholder="0"
                />
              </div>

              <div className="action-buttons">
                <button
                  type="button"
                  className={`status-btn ${actionType === 'Available' ? 'active-avail' : ''}`}
                  onClick={() => this.handleActionToggle('Available')}
                >
                  Set Available
                </button>
                <button
                  type="button"
                  className={`status-btn ${actionType === 'Block' ? 'active-block' : ''}`}
                  onClick={() => this.handleActionToggle('Block')}
                >
                  Block Dates
                </button>
              </div>

              <button type="button" className="btn-update" onClick={this.handleUpdate}>
                {actionType === '' ? 'UPDATE PRICE ONLY' : 'UPDATE CALENDAR'}
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default Calendar;
